/**
 * Prevents the "Easy Variant Images" app from scrolling the page to the top
 * when a variant is selected.
 *
 * The app rebuilds its image slider on variant change and calls
 * `window.scrollTo({ top: 0 })`. We drop only that scroll-to-top within a
 * short window after a variant selection, leaving every other scroll (and the
 * app's image swapping) intact.
 */
(() => {
  if (window.__variantScrollFixInstalled) return;
  window.__variantScrollFixInstalled = true;

  const SUPPRESS_MS = 4000;
  const VARIANT_SELECTORS = 'variant-selects, [data-product-form], .product__page';
  let suppressUntil = 0;

  // Arm suppression whenever a variant option is changed.
  document.addEventListener(
    'change',
    ({ target }) => {
      if (target?.closest?.(VARIANT_SELECTORS)) {
        suppressUntil = Date.now() + SUPPRESS_MS;
      }
    },
    true,
  );

  const nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = (...args) => {
    const [first, second] = args;
    const top = first && typeof first === 'object' ? first.top : second;

    // Drop programmatic scroll-to-top fired during a variant change.
    if (top === 0 && Date.now() < suppressUntil) return;

    return nativeScrollTo(...args);
  };
})();
